import React from 'react';
import { Link } from 'react-router-dom';

import mrm2Product from '../../../main/assets/images/mrm2-10/mrm2-10-product.webp';

export const Landing = () => (
  <section className="dreamX__description__content--wrapper dreamX__description__content--template-3 responsive__padding">
    <div className="dreamX__text--wrapper mrm2-landing-text-wrapper">
      <div className="dreamX__description__title__subtitle">
        <h3 className="dreamX__subtitle mrm2-landing-subtitle">
          OBJECTIVE: ACHIEVED
        </h3>
        <h1 className="dreamX__discover__title mrm2-landing-title">MRM2-10</h1>
      </div>
      <div className="dreamX__discover__grid--merge">
        <p className="dreamX__body mrm2-landing-description">
          The <span style={{ whiteSpace: 'nowrap' }}>MRM2-10</span> is a fully
          NDAA-compliant, EU-manufactured dual-use platform. Whether deployed
          for tactical or commercial applications, its uncompromising
          reliability and EW-resilience gives professional operators a decisive
          edge.
        </p>

        <div className="dreamX__discover--button">
          <Link
            to="/contact?product=mrm2-10"
            rel="noopener noreferrer"
            className="btn btn--primary btn--med"
            onMouseDown={event => event.preventDefault()}
          >
            Contact Us
          </Link>
        </div>
      </div>
    </div>
    <img
      style={{ objectFit: 'contain' }}
      src={mrm2Product}
      alt="MRM2-10 Drone"
      className="mrm2-landing-product"
    />
  </section>
);
